import Forms from './forms';
import Modal from './modal';
import NoData from './noData';
import TabBar from './tabBar';
import Sidebar from './sidebar';
import MovieList from './movieList';
import MovieCover from './movieCover';
import PartyCover from './partyCover';
import SearchField from './searchField';
import PublicHeader from './publicHeader';
import WatchPartyContent from './watchPartyContent';
import MovieDetailsContent from './movieDetailsContent';

export default {
	...Forms,
	Modal,
	NoData,
	TabBar,
	Sidebar,
	MovieList,
	MovieCover,
	PartyCover,
	SearchField,
	PublicHeader,
	WatchPartyContent,
	MovieDetailsContent
};
